import { smoothScrollTo } from "./Utils"

function JcpProcess() {
    const blocks = Array.from(document.querySelectorAll('.the-jcp-process__block'))
    const links = document.querySelectorAll('.the-jcp-process__scrollspy a')

    const scrollHandler = entries => {
        entries.forEach((entry, id) => {
            const section = entry.target
            const sectionId = section.id
            const sectionLink = document.querySelector(`a[href="#${sectionId}"]`)

            sectionLink.scrollTo({behavior: 'smooth'})

            switch (entry.isIntersecting) {
                case true:
                    sectionLink.classList.add('active')
                    break;
                case false:
                    sectionLink.classList.remove('active') 
                    break;
                default:
                    break;
            }
        })
    }

    const scrollHandlerOptions = {
        rootMargin: '-38.5% 0px'
    }

    const observer = new IntersectionObserver(scrollHandler, scrollHandlerOptions)

    blocks.forEach(section => observer.observe(section))
    // links.forEach(link => link.addEventListener('click', (event) => { 
    //     event.preventDefault()
    //     let linkId = String(event.target.hash.slice(1))
    //     console.log(event)
    //     smoothScrollTo({id: linkId})
    // }))
}

export default JcpProcess
